import * as React from "react";
import { Redirect, Route, Switch } from "react-router";
import LoginContainer from './../containers/LoginContainer';
import RegisterContainer from './../containers/RegisterContainer';
import ModuleContainer from '../containers/ModuleContainer';
import ModuleListComponent from 'src/components/modules/ModuleListComponent';
import UserListComponent from 'src/components/users/UserListComponent';
import ModulePreviewContainer from 'src/containers/ModulePreviewContainer';
import QuestionContainer from 'src/containers/QuestionContainer';
import EditUserComponent from 'src/components/users/EditUserComponent';
import HeaderComponent from 'src/components/common/header/HeaderComponent';
import SurveyListContainer from 'src/containers/SurveyListContainer';
import AddEditSurveyContainer from 'src/containers/AddEditSurveyContainer';
import PendingUserListComponent from 'src/components/users/PendingUserListComponent';
import RejectedUserListComponent from 'src/components/users/RejectedUserListComponent';
import DataCollectorDashboardContainer from 'src/containers/DataCollectorDashboardContainer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TOSTAR_DURATION } from 'src/constants/NotificationMessageConstant';
import ErrorComponent from '../components/common/ErrorComponent'
import { getLocalStorageValue } from '../effects/utils/local-storage';
import HQAdminContainer from 'src/containers/HQAdminContainer';
import UnauthorizedComponent from '../components/common/Unauthorized';
import PageNotFoundContainer from './../containers/PageNotFoundContainer';
import DashboardWebinarContainer from 'src/containers/DashboardWebinarContainer';
import SurveyReportsListContainer from 'src/containers/SurveyReportsListContainer';
import SurveyInternalReportsListContainer from 'src/containers/SurveyInternalReportsListContainer';
import CountryAssignment from './../components/login/profile';
import SurveyReportsContainer from 'src/containers/SurveyReportsContainer';
import HQAdminResponseContainer from 'src/containers/HQAdminResponseContainer';
import DataCollectorResponseContainer from 'src/containers/DataCollectorResponseContainer';
import ModuleQuestionReviewContainer from '../containers/ModuleQuestionReviewContainer';

const reload = () => window.location.reload();

const RouterComponent = (pr: any) => {
    return (
        <>
            <HeaderComponent />
            <ToastContainer
                autoClose={TOSTAR_DURATION}
                hideProgressBar={true}
                newestOnTop={true}
                draggable={true}
                pauseOnHover={true}
            />
            <Switch>
                <Redirect exact={true} from="/" to="/login" />
                <Route path="/assets/images/UN0515242-edited.jpg" onEnter={reload} />
                <Route path='/login' component={LoginContainer} />
                <Route path='/forgotpassword' component={LoginContainer} />
                <Route path='/register' component={RegisterContainer} />
                <Route path='/error' component={ErrorComponent} />
                <Route path='/reviewQuestions' render={(props) => (<ModuleQuestionReviewContainer {...props} currentUserData={getLocalStorageValue('user')} />)} />
                <Route path='/preview' component={ModulePreviewContainer} />
                <Route path='/survey/response' component={ModulePreviewContainer} />
                <Route path='/pagenotfound' component={PageNotFoundContainer} />
                <Route path='/unauthorized' component={UnauthorizedComponent} />
                <Route path='/webinar' component={DashboardWebinarContainer} />
                <Route path='/surveyreports' component={SurveyReportsListContainer} />
                <Route path='/internalreports' component={SurveyInternalReportsListContainer} />
                <Route path='/surveyreport' component={SurveyReportsContainer} /> 
                <Route path='/module' exact={true} render={
                    () => {
                        return validateRoute(ModuleContainer, [1, 2])
                    }
                } />
                <Route path='/module/:id' exact={true} render={
                    () => {
                        return validateRoute(ModuleContainer, [1, 2])
                    }
                } />
                <Route path='/module/questions/:id' render={
                    () => {
                        return validateRoute(QuestionContainer, [1, 2])
                    }
                } />
                <Route path='/modules' render={
                    () => {
                        return validateRoute(ModuleListComponent, [1, 2])
                    }
                } />
                <Route path='/users' render={
                    () => {
                        return validateRoute(UserListComponent, [1, 2])
                    }
                } />
                <Route path='/edituser' render={
                    () => {
                        return validateRoute(EditUserComponent, [1, 2])
                    }
                } />
                <Route path='/pendinguser' render={
                    () => {
                        return validateRoute(PendingUserListComponent, [1, 2])
                    }
                } />
                <Route path='/rejecteduser' render={
                    () => {
                        return validateRoute(RejectedUserListComponent, [1, 2])
                    }
                } />
                <Route path='/surveys' render={
                    () => {
                        return validateRoute(SurveyListContainer, [1, 2])
                    }
                } />
                <Route path='/survey/:id' exact={true} render={
                    () => {
                        return validateRoute(AddEditSurveyContainer, [1, 2])
                    }
                } />
                <Route path='/hq-admin-dashboard/:id' render={
                    () => {
                        return validateRoute(HQAdminContainer, [1, 4, 6])
                    }
                } />
                <Route path='/regional-admin-dashboard/:id' render={
                    () => {
                        return validateRoute(HQAdminContainer, [2, 7, 8])
                    }
                } />
                <Route path='/hq-admin-survey-response/:id' render={
                    () => {
                        return validateRoute(HQAdminResponseContainer, [1, 2, 4, 6])
                    }
                } />
                <Route path='/regional-admin-survey-response/:id' render={
                    () => {
                        return validateRoute(HQAdminResponseContainer, [2, 7, 8])
                    }
                } />
                <Route path='/Data-Collector-survey-response/:id' render={
                    () => {
                        return validateRoute(DataCollectorResponseContainer, [3])
                    }
                } />
                {<Route path='/data-collector-dashboard' render={
                    () => {
                        return validateRoute(DataCollectorDashboardContainer, [3], 'dataCollector')
                    }
                } />}
                <Route path='/country-assignment' render={
                    () => {
                        return validateRoute(CountryAssignment, [3], 'country-assignment')
                    }
                } />
            </Switch>
        </>
    );
};

// validate route, its parameter and redirecting to specific component
const validateRoute = (Component: any, ids: any, internalUser?: any) => {
    const localStorageuserData = getLocalStorageValue('user');
    if (internalUser === 'dataCollector') {
        if (!localStorageuserData) {
            return <Redirect to="/login" />
        }
        else if (localStorageuserData && localStorageuserData.roleId /* && ids.indexOf(localStorageuserData.roleId) > -1 */) {
            if ((!localStorageuserData.isInternalUser && localStorageuserData.activeCountryId !== null) || (localStorageuserData.isInternalUser && localStorageuserData.activeCountryId !== null)) {
                return (
                    <Component />
                )
            }
            else {
                return (
                    <Redirect to="/country-assignment" />
                )
            }
        }
        else {
            return <UnauthorizedComponent />
        }
    }
    else if (internalUser === 'country-assignment') {
        if (!localStorageuserData) {
            return <Redirect to="/login" />
        }
        else if (localStorageuserData && localStorageuserData.roleId && ids.indexOf(localStorageuserData.roleId) > -1) {
            if (localStorageuserData.isInternalUser && (localStorageuserData.activeCountryId === 0 || localStorageuserData.activeCountryId === null)) {
                return (
                    <Component />
                )
            }
            else {
                return (
                    <Redirect to="/data-collector-dashboard" />
                )
            }
        }
        else {
            return <UnauthorizedComponent />
        }
    }
    else {
        if (!localStorageuserData) {
            return <Redirect to="/login" />
        }
        else if (localStorageuserData && localStorageuserData.roleId && ids && ids.indexOf(localStorageuserData.roleId) > -1) {
            return (
                <Component userId={localStorageuserData.roleId} loginUserData={localStorageuserData} />
            )
        }
        else {
            return <UnauthorizedComponent />
        }
    }
}

export default RouterComponent;


// WEBPACK FOOTER //
// ./src/routes/routerComponent.tsx